import { INewsPagedRequest } from '../../../../model/apm/news/request/news-paged-request';
import { INewsCategoryResponse } from '../../../../model/apm/news/response/news-category-response';
import { INewsResponse } from '../../../../model/apm/news/response/news-response';

export type NewsSearchState = {
    parameters: INewsPagedRequest;
    searchTrigger: number;
    categories: INewsCategoryResponse[];
    drawer: { open: boolean; news?: INewsResponse };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
    setCategories = 'setCategories',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
}

export const NewsSearchReducer = (state: NewsSearchState, action: any): NewsSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.setCategories:
            return { ...state, categories: payload };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, news: payload } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
